module.exports = __webpack_public_path__ + "static/media/circled-play-icon.25d13269.svg";